import request from '@/utils/request'

// export const getdatalist = (params: any) =>
//   request({
//     url: '/api/resultsanalyse',
//     method: 'get',
//     params
//   })
export const getdatalist = (params: any) =>
  request({
    url: '/examdetail/getExamInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const getresultData = (params: any) =>
  request({
    url: '/examdetail/getExamInfoById',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const getresultData = (params: any) =>
//   request({
//     url: '/api/resultsanalyse/:id',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })

// export const getstudentData = (params: any) =>
//   request({
//     url: '/api/getstudentlist',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const getstudentData = (params: any) =>
  request({
    url: '/examdetail/getExamStudentInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const getrasheettype = (params: any) =>
//   request({
//     url: '/api/getrasheettype',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const getrasheettype = (params: any) =>
  request({
    url: '/examdetail/getJudgeInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const getrasheetdetail = (params: any) =>
//   request({
//     url: '/api/getrasheetdetail',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const getrasheetdetail = (params: any) =>
  request({
    url: '/examdetail/getJudgeDetailScore',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })